/**
 * **Das Kürzel im runden Kreis — aus Zeichen, nicht aus Code-Einheiten**
 * (Durchgang 03.10.2026, K-02).
 *
 * `w[0]` nimmt die erste UTF-16-Einheit: Aus „PB-Süd 👷 Einkauf" wurde „P"
 * und ein halbes Ersatzzeichen. Hier zählt je Wort der erste Buchstabe oder
 * die erste Ziffer; Wörter ohne einen davon (ein Emoji, ein „&") überspringt
 * das Kürzel. „Hempen Agrar" bleibt „HA", ein einzelnes Wort gibt seine
 * ersten zwei Buchstaben.
 */
export function kuerzelAus(name: string, laenge = 2): string {
  const zeichen = (wort: string): string[] => Array.from(wort).filter((z) => /[\p{L}\p{N}]/u.test(z));
  const woerter = name.split(/[\s.]+/).map(zeichen).filter((z) => z.length > 0);
  const erste = woerter.map((z) => z[0]!);
  if (erste.length < laenge && woerter[0]) erste.splice(1, 0, ...woerter[0].slice(1, 1 + laenge - erste.length));
  return erste.slice(0, laenge).join("").toUpperCase();
}
